import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import PasswordValidator from '../../../common/PasswordValidator';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updatePassword } from '../../../../services/operations/authApi';
import { toast } from 'react-hot-toast';

const UpdatePassword = ({ user }) => {
    const [showPassword, setShowPassword] = useState();
    const [showConfirmPassword, setShowConfirmPassword] = useState();
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const handleUpdatePassword = (data) => {
        try {
            dispatch(updatePassword(data.oldPassword, data.newPassword, user?.email, user?.firstName, navigate));
            
            reset({
                oldPassword: '',
                newPassword: '',
            })
            
            setPassword('');
        } catch (error) {
            toast.error('Password update failed. Please try again or contact support.');
        }
    }
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }

    return (
        <div className='w-full'>
            <form onSubmit={handleSubmit(handleUpdatePassword)}>
                <div className='my-10 bg-richblack-800 rounded-xl border border-richblack-700 p-8 flex flex-col gap-y-10'>
                    <h1 className='text-lg font-semibold'>Change Password</h1>
                    <div className='flex md:flex-row flex-col gap-x-10 md:gap-y-0 gap-y-6'>
                        <label className='relative w-full'>
                            <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Old Password</p>
                            <input
                                className='w-full p-[12px] pr-10 bg-richblack-700 rounded-[0.5rem] text-richblack-5 outline-none'
                                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                type={showConfirmPassword ? 'text' : 'password'}
                                name='confirmPassword'
                                placeholder='Old Password'
                                {...register('oldPassword', {
                                    required: true,
                                })}
                            />
                            {errors.oldPassword && (<span className='text-pink-200 text-sm absolute -bottom-6 left-0 right-0'>Please Enter Old Password</span>)}
                            <span className='absolute right-3 top-[38px] z-[10] cursor-pointer text-2xl text-richblack-100' onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                {showConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                            </span>
                        </label>
                        <label className='relative w-full'>
                            <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>New Password</p>
                            <input
                                className='w-full p-[12px] pr-10 bg-richblack-700 rounded-[0.5rem] text-richblack-5 outline-none'
                                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                                type={showPassword ? 'text' : 'password'}
                                name='newPassword'
                                placeholder='New Password'
                                {...register('newPassword', {
                                    required: { value: true, message: 'Please Enter Password' },
                                    onChange: handlePasswordChange,
                                    value: password,
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-])[^ ]{8,}$/,
                                        message: 'Must meet all validation criteria',
                                    }
                                })}
                            />
                            {errors.newPassword && (<span className='text-pink-200 text-sm absolute -bottom-6 left-0 right-0'>{errors.newPassword.message}</span>)}
                            <span className='absolute right-3 top-[38px] z-[10] cursor-pointer text-2xl text-richblack-100' onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                            </span>
                            <PasswordValidator password={password} />
                        </label>
                    </div>
                </div>
                <div className='flex justify-end gap-x-5'>
                    <button
                        type='reset'
                        onClick={() => (navigate('/dashboard/profile'))}
                        className='rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-100'>
                        Cancel
                    </button>
                    <button
                        type='submit'
                        className='flex items-center bg-yellow-50 rounded-md py-2 px-5 font-semibold text-richblack-900'>
                        Update
                    </button>
                </div>
            </form>
        </div>
    )
}

export default UpdatePassword;